'use strict';

function reportErrorHandler(/* errorEvent */) {
    return false;
}

function setup(window, logger, options) {
    var rethrowErrors;
    var externalHandler;
    var isHandlingError;

    options = options || {}; // eslint-disable-line no-param-reassign

    rethrowErrors = !!options.rethrowErrors;
    externalHandler = typeof options.customErrorHandler == 'function' ?
                        options.customErrorHandler : reportErrorHandler;

    isHandlingError = false;

    function windowErrorHandler(errorEvent) {
        // Ignore exception in our dependencies but report them
        if (isHandlingError) return true;

        try {
            isHandlingError = true;

            // Let external handler prevent the reporting of errors
            if (externalHandler(errorEvent) !== true) {
                logger.error('global.error', {
                    'errorEvent.message': errorEvent.message,
                    'errorEvent.filename': errorEvent.filename,
                    'errorEvent.lineno': errorEvent.lineno,
                    'errorEvent.colno': errorEvent.colno,
                    'errorEvent.error': errorEvent.error
                });
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('error during global exception reporting', e);
        } finally {
            isHandlingError = false;
        }

        if (!rethrowErrors) {
            errorEvent.preventDefault();
            return false;
        }

        return undefined;
    }

    // Note: the modern event listener doesn't contain any info on FF < 30 and IE < 10
    window.addEventListener('error', windowErrorHandler);
}

module.exports = {
    setup: setup
};
